module.exports = __webpack_public_path__ + "img/certificate12.632aa91e.png";